import NoResults from "./no-results";

export default NoResults;
